import { baseDialogStyles } from 'assets/styles/components/Dialog.styles';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  ...baseDialogStyles(theme),
}));

export default useStyles;
